
export class ThermographyLinkPinVM {
    public PinNo: number;
    public Position: string;
    public Evaluation: number;
    public comment: string;
    public image: string;
}

export class  ThermographynspectionVM{
    public InspectionDate:Date;
    public EquipmentId:number;
    public SMU:number;
}

export class ThermographyInspectionDataVM
{
    public  InspectionId :number;
    public  InspectionDate: Date
    public  SMU :number;
    public  Comment:string;
    public  trackSagL :number;
    public  trackSagR :number;
    public  Frames :FramList;
    public  Chains:ChainList;
    public  Release:boolean;
    public AdditionalComponents:AdditionalCompList;

}

export class AdditionalCompList{
    public  Additional_L :ThermographyInfoVM[];
    public  Additional_R :ThermographyInfoVM[];
    public  Additional_No :ThermographyInfoVM[];
}
export class FramList
{
    public  FrameLSerial :string;
    public  FrameRSerial :string;
    public  FrameL :ThermographyInfoVM[];
    public  FrameR :ThermographyInfoVM[];
}

export class ChainList
{
    public  ChainLSerial:string;
    public  ChainRSerial :string;

    public  CMU_Left :number;
    public  CMU_Right  :number;

    public  ChainR :ThermographyInfoVM[];
    public  ChainL :ThermographyInfoVM[];
}



export class ThermographyInfoVM
{
    public  DetailId :number;
    public  Eval:string;
    public  Position :number;
    public  ComponentName :string;
    public  EquintID :number;
    public  Side :number;
    public  Image :string;
    public  CompImage:string;
    public  Comment:string;
    public  CMU :number;
    public CompartTypeId:number;
    public AdditionalCompId:number;
    public    NewFileName:string
    public Extension:string
    public FilePreview:string;
}